import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MaterialTypography from '@material-ui/core/Typography';

const Typography = forwardRef(
    ({ breadCrumb, uppercase, readOnlyInput, ...props }, ref) => {
        const attrs = { ref, className: [] };

        if (uppercase) {
            attrs.className.push('NeptuneTypography-uppercase');
        }

        if (breadCrumb) {
            attrs.className.push(`NeptuneTypography-breadCrumb-${breadCrumb}`);
        }

        if (readOnlyInput) {
            attrs.className.push('NeptuneTypography-readOnlyInput');
        }

        attrs.className = attrs.className.join(' ').trim();

        return <MaterialTypography {...attrs} {...props} />;
    }
);

Typography.displayName = 'NeptuneTypography';

Typography.propTypes = {
    ...MaterialTypography.propTypes,
    readOnlyInput: PropTypes.bool,
    uppercase: PropTypes.bool,
    breadCrumb: PropTypes.oneOf(['current', 'inactive'])
};

Typography.defaultProps = {
    ...MaterialTypography.defaultProps,
    readOnlyInput: null,
    uppercase: null,
    breadCrumb: null
};

export default Typography;
